var LoadExternalScript = function (props) {
    var src = props.src, id = props.id, onLoad = props.onLoad, onError = props.onError;
    if (!document.getElementById(id)) {
        var script = document.createElement("script");
        script.src = src;
        script.id = id;
        if (onLoad)
            script.onload = onLoad;
        if (onError)
            script.onerror = onError;
        if (document.body) {
            document.body.appendChild(script);
        }
    }
    else if (onError) {
        onError("script already loaded");
    }
    return null;
};
export default LoadExternalScript;
